<template>
  <v-card>
    <v-card-title primary-title>
      <h3 class="headline mb-0">{{ register ? 'Register' : 'Login' }} with</h3>
    </v-card-title>

    <v-card-text v-if="showError">
      <v-alert
      v-model="showError"
      type="error"
      icon="warning"
      dismissible>
        {{ errorMessage }}
      </v-alert>
    </v-card-text>

    <v-card-actions>
      <v-btn
      @click="loginWithProvider('google.com')"
      :disabled="isUpdatingUser"
      block
      flat>
        <v-avatar tile size="18px" left>
          <img src="@/assets/google_64.png" alt="Google">
        </v-avatar>
        Google
      </v-btn>
    </v-card-actions>

    <v-card-actions>
      <v-btn
      @click="loginWithProvider('facebook.com')"
      :disabled="isUpdatingUser"
      block
      flat>
        <v-avatar tile size="18px" left>
          <img src="@/assets/facebook_64.png" alt="Facebook">
        </v-avatar>
        Facebook
      </v-btn>
    </v-card-actions>

  </v-card>
</template>

<script>
// import { firebase, auth } from '@/firebase.js';
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapActions } = createNamespacedHelpers('auth')

export default {
  name: 'SignWithCard',

  data() {
    return {
      debug: false,

      showError: false,
      errorMessage: ''
    }
  },

  props: {
    register: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapState({
      isUpdatingUser: state => state.isUpdatingUser, // map `this.user` to `this.$store.state.users.isUpdatingUser`
    }),
  },

  methods: {
    ...mapActions([
      'loginUserWithProvider', // map `this.loginUserWithProvider(providerName)` to `this.$store.dispatch('users/loginUserWithProvider', providerName)`
      'signOutUser' // map `this.signOutUser()` to `this.$store.dispatch('users/signOutUser')`
    ]),

    loginWithProvider(providerName) {
      if (this.debug) console.log(this.$options.name+'.loginWithProvider()');
      this.loginUserWithProvider(providerName)
      .then(() => {
        if (this.debug) console.log(this.$options.name+'.loginWithProvider() login with provider ok');
        this.showError = false;
      })
      .catch((error) => {
        if (this.debug) console.log(this.$options.name+'.loginWithProvider() error:',error);
        if (error.message) this.errorMessage = error.message
        else this.errorMessage = error
        this.showError = true
        this.signOut()
      })
    },

    signOut() {
      if (this.debug) console.log(this.$options.name+'.signOut()');
      this.signOutUser()
      .then((response) => {
        // Sign-out successful.
        if (this.debug) console.log(this.$options.name+'.signOut() response:',response);
      })
      .catch((error) => {
        // An error happened.
        if (this.debug) console.warn(this.$options.name+'.signOut() error:',error);
      });
    }

  }
}
</script>

<style scoped>  /* "scoped" attribute limit the CSS to this component only */
.v-avatar[left] {
  margin-right: 16px;
}
</style>